import * as Yup from 'yup';

export default Yup.object().shape({
  rejectionReason: Yup.string().required('SCHEMA_ERRORS.COMMENT_REQUIRED'),
});
